import script from "./ProductEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditor.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditor.vue?vue&type=style&index=0&id=750299e4&scoped=true&lang=css"
import "./ProductEditor.vue?vue&type=style&index=1&id=750299e4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750299e4"]])

export default __exports__